import React from 'react'
import Img from '@/lib/Img'
import Richtext from '@/lib/rt/Richtext'

import { MdChevronRight } from 'react-icons/md'
import connect from '@/images/connect.svg'
import discover from '@/images/discover.svg'
import guide from '@/images/guide.svg'
import support from '@/images/support.svg'

const format = date => !!date && new Intl.DateTimeFormat('en-US', {
	month: 'short',
	day: 'numeric',
}).format(new Date(date + 'T00:00:00.000'))

const Event = ({ title, type, category, startDate, endDate, _rawRichtext, image, url, index }) => {
	const dates = [startDate, endDate].filter(Boolean)

	const getIcon = category => {
		switch (category) {
			case 'Connect': return connect
			case 'Discover': return discover
			case 'Guide': return guide
			case 'Support': return support
			default: return false
		}
	}

	return (
		<dl>
			<figure>
				<Img className="w-full" image={image} />
			</figure>
			<dt className="h3 p-4">
				<p>{title}</p>
				<p className="font-normal">
					{dates.map((date, key) => (
						<React.Fragment key={key}>
							<time dateTime={date}>{format(date)}</time>
							{key < dates.length - 1 && ' - '}
						</React.Fragment>
					))}
				</p>
			</dt>
			<dd className="p-4 pt-0">
				<Richtext raw={_rawRichtext} />
				<p className="flex items-center justify-between gap-4 font-bold md:text-xl mt-4">
					<p>
						{!!url && <a className="link with-icon" href={url}>See Event <MdChevronRight /></a>}
					</p>
					<img src={getIcon(category)} alt={category} />
				</p>
			</dd>
		</dl>
	)
}

export default Event
